import { render, staticRenderFns } from "./OrdermanSettings.vue?vue&type=template&id=0742fad6&scoped=true&"
import script from "./OrdermanSettings.vue?vue&type=script&lang=js&"
export * from "./OrdermanSettings.vue?vue&type=script&lang=js&"
import style0 from "./OrdermanSettings.vue?vue&type=style&index=0&id=0742fad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0742fad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VIcon,VListItemContent,VListItemIcon,VListItemTitle,VSelect,VTab,VTabItem,VTabs,VTabsItems})
